import React from 'react';
import { Text, StyleSheet } from 'react-native';
import Theme  from '../../theme';
import { scaleText } from '../../utils';

export const TabBarLabel = ({ title, color, customLabelStyle }) => (
  <Text style={[styles.title, { color }, customLabelStyle]}>{title}</Text>
);

const styles = StyleSheet.create({
  title: {
    ...Theme.textStyle.bodyCopyReg,
    fontSize: scaleText(14),
  },
});
